import { type ISbStoryData } from '@storyblok/react'
import { type FC } from 'react'

import { type CmsAlternateUrlsMetaData } from '../../model/storyAccessors/CmsAlternateUrlsMetaData'
import { storyAccessorHasNoIndexInSeoRobots } from '../../model/storyAccessors/storyAccessorHasNoIndexInSeoRobots'
import { type StoryblokPageContentType } from '../../model/storyblokPageContentTypes'

type CmsSeoHrefLangsProps = {
  hrefLangs: CmsAlternateUrlsMetaData[]
  story: ISbStoryData<StoryblokPageContentType>
}

export const CmsSeoHrefLangs: FC<CmsSeoHrefLangsProps> = ({
  hrefLangs,
  story,
}) => {
  if (storyAccessorHasNoIndexInSeoRobots(story)) {
    return null
  }

  return (
    <>
      {hrefLangs.map((item) => (
        <link
          href={item.href}
          hrefLang={item.hrefLang}
          key={item.href}
          rel="alternate"
        />
      ))}
    </>
  )
}
